import { useEffect } from 'react'
import {
  init as initFullStory,
  isInitialized as isFSInitialized,
  FullStory
} from '@fullstory/browser'
import { useSelector } from 'react-redux'
import { getHasPartyId, getProfile } from 'modules/auth/AuthSelector'
import config from 'site.config'
import { withServices } from 'services/ServiceContext'
import Session from 'services/SessionService'

const {
  configuration: { envVars }
} = config

const ORG_ID = envVars.REACT_APP_FULLSTORY_ORG_ID || ''
const CONFIG = envVars.REACT_APP_FULLSTORY_CONFIG || {}

export const useFullStoryInit = () => {
  useEffect(() => {
    if (!ORG_ID) {
      console.warn('FullStory Org ID not configured')
      return
    }
    if (isFSInitialized()) {
      return
    }
    try {
      initFullStory({ orgId: ORG_ID, ...CONFIG })
      console.log('FullStory initialized')
    } catch (error) {
      console.error('[FS] - Failed to initialize FS:', error)
    }
  }, [])
}

// Prefer calling this on logout, after init has already happened.
export const FsClearUserIdentifyer = () => {
  if (!ORG_ID) return
  FullStory('clearUserCookie')
}

// Hook that binds identity when auth + interactionId are available
export const useFullStorySetUserIdentifyer = () => {
  const hasPartyId = useSelector(getHasPartyId)
  const profile = useSelector(getProfile)

  useEffect(() => {
    const SessionService = new Session()
    if (!ORG_ID) return
    if (!hasPartyId) return

    const interactionId = SessionService.getFromCache('interactionId', '')

    FullStory('setIdentity', {
      uid: String(interactionId),
      properties: {
        partyId: profile?.info?.user?.partyId || ''
      }
    })
    console.log('FullStory identity set', {
      interactionId,
      partyId: profile?.info?.user?.partyId
    })
  }, [hasPartyId, profile])
}

// Component that can live under <ServiceProvider> and <Provider>
export const FsUserIdentityBinder = () => {
  useFullStorySetUserIdentifyer()
  return null
}

// Export a ready-to-render binder component that injects SessionService
export const FullStoryIdentityBinder = withServices(resolve => {
  return {
    SessionService:
      typeof resolve === 'function' ? resolve('SessionService') : undefined
  }
})(FsUserIdentityBinder)
